import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3924f73c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 0,
  style: {"margin-top":"20px"},
  class: "info"
}
const _hoisted_3 = {
  key: 1,
  class: "json"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"gray"} }, "Value:", -1 /* HOISTED */))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return ($props.proposal !== undefined)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys($props.proposal.messages), (key) => {
          return (_openBlock(), _createElementBlock("div", {
            key: key,
            class: "box"
          }, [
            ($props.proposal.messages[key] != null)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createElementVNode("span", null, _toDisplayString(key), 1 /* TEXT */)
                ]))
              : _createCommentVNode("v-if", true),
            ($props.proposal.messages[key] != null)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _hoisted_4,
                  _createVNode($setup["VueJsonPretty"], {
                    data: $props.proposal.messages[key]
                  }, null, 8 /* PROPS */, ["data"])
                ]))
              : _createCommentVNode("v-if", true)
          ]))
        }), 128 /* KEYED_FRAGMENT */))
      ]))
    : _createCommentVNode("v-if", true)
}